import React from 'react';
import LoanVisualizer from './LoanVisualizer';
import './App.css';

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="py-4 bg-white shadow-sm">
        <div className="container mx-auto px-4">
          <h1 className="text-xl font-bold text-blue-900">Loan Calculator & Visualizer</h1>
        </div>
      </header>

      <main className="container mx-auto px-4 py-6">
        <LoanVisualizer />
      </main>

      <footer className="py-6 bg-white border-t border-gray-200">
        <div className="container mx-auto px-4 text-center text-gray-500 text-sm">
          © {new Date().getFullYear()} Loan Calculator & Visualizer. All rights reserved.
        </div>
      </footer>
    </div>
  );
}

export default App;
